import { withInstall } from '@hd-front-end/utils'
import Empty from './src/empty.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElEmpty: SFCWithInstall<typeof Empty> = withInstall(Empty)
export default ElEmpty

export * from './src/empty'
export type { EmptyInstance } from './src/instance'
